import { IPoint2d } from '@/editor/math/IPoint2d';
import { PolyBool, GeometryEpsilon, Vec2 } from '@velipso/polybool';

export enum BooleanPolygonType {
  Difference = 'difference',
  Intersect = 'intersect',
  Union = 'union',
  Xor = 'xor'
}

interface IBooleanPolygonParams {
  main: IPoint2d[][];
  assistant: IPoint2d[][];
  /** 布尔运算类型 */
  type: BooleanPolygonType.Difference | BooleanPolygonType.Intersect | BooleanPolygonType.Xor;
  /** 精度误差 */
  epsilon?: number;
}

export function booleanPolygon({ main, assistant, type, epsilon = 0.0000000001 }: IBooleanPolygonParams) {
  const _mainOutlines = {
    regions: main.map((outline) => {
      return outline.map<Vec2>((pt) => {
        return [pt.x, pt.y];
      });
    }),
    inverted: false
  };
  const _assistantOutlines = {
    regions: assistant.map((outline) => {
      return outline.map<Vec2>((pt) => {
        return [pt.x, pt.y];
      });
    }),
    inverted: false
  };

  const polybool = new PolyBool(new GeometryEpsilon(epsilon));
  try {
    const differences = polybool[type](_mainOutlines, _assistantOutlines);
    return differences.regions.map((region) => {
      return region.map((pt) => {
        return { x: pt[0], y: pt[1] };
      });
    });
  } catch (error) {
    console.error(type + ' error: ');
    console.log(error);
    console.log(main, assistant);

    return main;
  }
}

export function booleanPolygonUnion(polygons: IPoint2d[][], epsilon = 0.0000000001) {
  const polybool = new PolyBool(new GeometryEpsilon(epsilon));
  try {
    const _polygon = polygons.map((polygon) => {
      return {
        regions: [
          polygon.map<Vec2>((pt) => {
            return [pt.x, pt.y];
          })
        ],
        inverted: false
      };
    });

    let segments = polybool.segments(_polygon[0]);
    for (let i = 1; i < polygons.length; i++) {
      const seg2 = polybool.segments(_polygon[i]);
      const comb = polybool.combine(segments, seg2);
      segments = polybool.selectUnion(comb);
    }
    return polybool.polygon(segments).regions.map((region) => {
      return region.map((pt) => {
        return { x: pt[0], y: pt[1] };
      });
    });
  } catch (error) {
    console.error('booleanPolygonUnion error: ');
    console.log(error);
    console.log(polygons);

    return polygons;
  }
}
